import logger from '../utils/rbmc.logger';
import urlUtils from '../utils/rbmc.url-utils'
import spinner from '../utils/rbmc.spinner';

const adyenService = {
    dropinContainer: undefined,
    dropinComponent: null,
    paypalComponent: null,
    dropInData:      undefined,
    paymentSelected: false,
    checkout:        null,
    paypal:          false,

    handlePaypal: function (component) {
        adyenService.paypal = component.props.type === 'paypal';
    },

    removeExcessIcons() {
        // Hide icon in title wrapper if option have brands as siblings
        const paymentMethods = $('.adyen-checkout__payment-method');
        if (paymentMethods.length) {
            $.each(paymentMethods, function (_, item) {
                $(item).find('.adyen-checkout__payment-method__header').siblings()
                const paymentRowElements = $(item).find('.adyen-checkout__payment-method__header').children();
                $.each(paymentRowElements, function (_, child) {
                    if ($(child).hasClass('adyen-checkout__payment-method__brands')) {
                        $(item).find('.adyen-checkout__payment-method__header__title .adyen-checkout__payment-method__image')
                               .css({display: 'none'})
                    }
                });
            })
        }
    },

    showPayButton() {
        (async () => {
            if (adyenService.dropinContainer.data('paypal-payment')) {
                await adyenService.createAdyenInstance(); // wait for checkout instance to be created
                adyenService.paypalComponent = adyenService.checkout.create('paypal', {showPayButton: true});
                adyenService.paypalComponent.mount("#paypal-container");
                adyenService.paypal = true;
                $('#paypal-container').show();
            } else {
                adyenService.initDropIn();
                $('#finalPaymentSubmit').show();
            }
        })()
    },

    onSelect(component) {
        logger.log('adyen onSelect', component)
        adyenService.paymentSelected = true;
        adyenService.handlePaypal(component);

    },

    onReady() {
        adyenService.removeExcessIcons();
    },

    onError(error) {
        if (error.name === 'CANCEL') {
            logger.log('User cancelled payment');
        } else {
            logger.log("Error: " + error.name);
            logger.log("Message: " + error.message);
        }
    },

    cacheSelectors() {
        this.dropinContainer = $('#dropin-container');
        this.dropInData      = $('#js-payment-data').data('dropin-data');
    },

    onSubmit: (state, dropin) => {
        if (adyenService.paypal) {
            adyenService.placeOrder(state);
        } else {
            adyenService.reviewOrder(state);
        }
    },

    reviewOrder: (state) => {
        const stateData = state !== undefined ? state.data : {};
        $.ajax({
            url:         `${urlUtils.getBaseUrl()}checkout/multi/payment-method`,
            method:      'POST',
            contentType: 'application/json',
            data:        JSON.stringify({
                state: stateData, paypal: adyenService.paypal
            })
        }).done((response) => {
            if (response.success) {
                if (adyenService.paypal === true) {
                    adyenService.trackSelectedPaymentMode('paypal');
                } else {
                    adyenService.trackSelectedPaymentMode(stateData.paymentMethod.type);
                }

                window.location.href = urlUtils.getBaseUrl() + 'checkout/multi/summary';
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in for review order`)
        });
    },

    placeOrder: (state) => {
        const stateData = state !== undefined ? state.data : {};
        $.ajax({
            url:         `${urlUtils.getBaseUrl()}checkout/multi/summary/placeOrder`,
            contentType: 'application/json',
            method:      'POST',
            data:        JSON.stringify({
                state: stateData, paypal: adyenService.paypal
            })
        }).done((response) => {
            if (response.error !== true) {
                if (response.paymentsAction) {
                    if (response.paymentsAction.paymentMethodType === "bcmc_mobile") {
                        adyenService.handleBcmcModal();
                    }
                    adyenService.handleAction(response.paymentsAction);
                } else {
                    window.location.href = response.redirectUrl;
                }
            } else if (response.noDeliveryAddress === true) {
                $('#placeOrderNoDeliveryAddress').removeClass('d-none');
            } else if (response.inconsistentAddresses === true) {
                $('#placeOrderInconsistentAddresses').removeClass('d-none');
            } else if (response.cartNotCalculated === true) {
                $('#placeOrderCartNotCalculated').removeClass('d-none');
            } else {
                window.location.href = response.redirectUrl;
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in for placing order`)
        });
    },

    onAdditionalDetails: (state, dropin) => {
        $.ajax({
            url: `${urlUtils.getBaseUrl()}checkout/payment/return/paypal/`, method: 'POST', contentType: 'application/json', data: JSON.stringify({
                state: state.data
            })
        }).done((response) => {
            if (response.redirectUrl) {
                window.location.href = `${urlUtils.getBaseUrl()}${response.redirectUrl}`;
            } else {
                window.location.reload;
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in after paypal return`)
        })
    },

    buildConfiguration() {
        return {
            paymentMethodsResponse:      adyenService.dropInData.paymentMethodsResponse,
            clientKey:                   adyenService.dropInData.clientKey,
            locale:                      adyenService.dropInData.locale,
            environment:                 adyenService.dropInData.environment,
            onError:                     adyenService.onError,
            onSubmit:                    adyenService.onSubmit,
            onAdditionalDetails:         adyenService.onAdditionalDetails,
            showPayButton:               false,
            analytics:                   {
                enabled: adyenService.dropInData.analytics
            },
            paymentMethodsConfiguration: {
                card:     {
                    enableStoreDetails: adyenService.dropInData.storeCards,
                    hasHolderName:      true,
                    holderNameRequired: true,
                    styles:             {
                        base:        {
                            fontFamily: `'BullText', Helvetica, Arial, sans-serif`,
                            fontSize:   '18px !important',
                        },
                        error:       {
                            color: '#DD013E'
                        },
                        placeholder: {
                            opacity:       0.2,
                            fontFamily:    `'BullText', Helvetica, Arial, sans-serif`,
                            fontSize:      '18px',
                            fontWeight:    '500',
                            fontStyle:     'normal',
                            lineHeight:    '1.33',
                            letterSpacing: 'normal',
                            color:         '#1d1d1'
                        }
                    }
                },
                paypal:   {
                    amount:      {
                        currency: adyenService.dropInData.currency,
                        value:    adyenService.dropInData.amount
                    },
                    intent:      adyenService.dropInData.intent,
                    environment: adyenService.dropInData.environment,
                    countryCode: adyenService.dropInData.countryCode
                },
                applepay: {
                    amount:      {
                        currency: adyenService.dropInData.currency, value: adyenService.dropInData.amount
                    },
                    countryCode: adyenService.dropInData.countryCode
                }
            }
        }
    },

    async createAdyenInstance() {
        const configuration = this.buildConfiguration();

        adyenService.checkout = await AdyenCheckout(configuration);

        return adyenService.checkout.create('dropin', {
            openFirstPaymentMethod: false,
            onSelect:               adyenService.onSelect,
            onReady:                adyenService.onReady
        });
    },

    initDropIn() {
        // In case zero value order (GC, Voucher...)
        if (this.dropinContainer.data('no-payment')) {
            return;
        }
        (async () => {
            adyenService.dropinComponent = await adyenService.createAdyenInstance();
            adyenService.dropinComponent.mount('#dropin-container');
            console.log(adyenService.dropinComponent)
        })()
    },

    reviewPayment() {
        if (adyenService.paypal) {
            adyenService.reviewOrder(undefined);
        } else {
            adyenService.dropinComponent.submit()
        }
    },

    trackSelectedPaymentMode(paymentMode) {
        paymentMode = paymentMode === 'scheme' ? 'creditcard' : paymentMode;
        if (paymentMode) {
            RedBull.tracking.checkout.UA.ecommerce.checkout.actionField.option = RedBull.util.capitalizeFirstLetter(paymentMode);
            RedBull.tracking.checkout.GA4.ecommerce.payment_type               = RedBull.util.capitalizeFirstLetter(paymentMode);
            dataLayer.push(RedBull.tracking.checkout.UA);
            dataLayer.push(RedBull.tracking.checkout.GA4);
        }
    },

    handleAction(action) {
        if (adyenService.paypal) {
            adyenService.paypalComponent.handleAction(action);
        } else {
            adyenService.dropinComponent.handleAction(action);
        }
    },
    handleBcmcModal() {
        const dropinContainer = $("#dropin-wrapper");
        const paymentModal    = $('.payment-modal');
        dropinContainer.removeClass("d-none");
        dropinContainer.appendTo(paymentModal.find(".modal-content"));
        paymentModal.modal({
            backdrop: 'static',
            keyboard: false
        });
        paymentModal.modal('show');
        spinner.spinnerVisibility(false);

        paymentModal.on("hide.bs.modal", function () {
            window.location.href = urlUtils.getBaseUrl() + "/checkout/multi/payment-method/"
        });
    }

}

export default adyenService
